<template>
    <v-layout row wrap>
        <v-form ref="form" style="width: 100%">
            <v-text-field :value="value"
                          @input="val => $emit('input',val)"
                          full-width min="1"
                          :disabled="disabled"
                          :rules="[v => !!v || 'This Field is Required']"
                          type='number'
                          label="Select Ride To Join The Bookings With"/>
        </v-form>
        <v-flex xs12>
            <v-layout justify-end>
                <v-btn :loading="disabled" flat large color="primary" @click="selectRide">Join Ride
                </v-btn>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        props: ['value','disabled'],
        name: "choose-ride-component",
        methods: {
            selectRide() {
                if (!this.$refs.form.validate()) return;
                this.$emit('rideSelected');
            }
        }
    }
</script>

<style scoped>

</style>